/* Diese Typensammlungen sollen die AddresswizardTypes großteils ablösen! */
import DocumentsFileList from '../AddressWizard/AddressDocuments/AddressDocumentsEditor/Files/DocumentsFileList';
import DocumentsEditorForm from '../AddressWizard/AddressDocuments/AddressDocumentsEditor/Form/DocumentsEditorForm';



//const Classnames = [
//    "vt_addresses" ,
//    "vt_organisations",
//    "organisations_external",
//    "organisations_internal",
//    "persons",
//    "associates",
//    "contact_persons",
//    "vt_telecommunication"];

enum Classnames {
    "vt_addresses" = "vt_addresses",
    "vt_organisations" = "vt_organisations",
    "organisations_external" = "organisations_external",
    "organisations_internal" = "organisations_internal",
    "persons" = "persons",
    "associates" = "associates",
    "contact_persons" = "contact_persons",
    "vt_telecommunication" = "vt_telecommunication",
}
type Classname = keyof typeof Classnames;

export {
    type Classname,
    Classnames,
    type AddressTypes,
    DocumentsEditorForm,
    DocumentsFileList
}

namespace AddressTypes {


    interface Salutation extends more.EntityAPIResult {
       
    }

    interface AcademicTitle extends more.EntityAPIResult {
        description_short: string;
    }

    export interface Country extends more.EntityAPIResult {
        description: string;
        lc_iso_alpha_2?: string;
    }

    export interface PostalCode extends more.EntityAPIResult {
        postal_code: string;
        city: string;
        ref_country: Country;
    }


    export interface Citizenship extends more.EntityAPIResult {
        ID: string;
        Classname: string;
        lc_iso_alpha_2: string;
        description: string;
    } 

    interface File extends more.EntityAPIResult {
        filename: string;
    }

    interface HtFile extends more.EntityAPIResult {
        ref_vt_file: File;
    }

    export interface AddressCategoryEntity extends more.EntityAPIResult {
        description: string;
    }

    export interface HtAddressCategoryEntity extends more.EntityAPIResult {
        c_address_category: string;
        ref_address_category: AddressCategoryEntity;
    }

    export interface TelecommunicationEntity extends more.EntityAPIResultExtended {
        telecom_code: string;
        is_main_connection?: boolean;
    }

    
    export interface PersonEntity extends AddressEntity_Base {
        ref_salutation: Salutation;
        ref_academic_title_prefix: AcademicTitle;
        ref_academic_title_suffix: AcademicTitle;
        name_first: string;
        ref_citizenship: Citizenship;
        day_of_birth: Date;
        day_of_death: string;
        is_opus_address: boolean;
        born: string;
        died: string;

    }

 
        interface JobTitle {
        ID: string;
        value: string;
        description: string;

    }

    //export interface FunctionalSubGroup extends more.EntityAPIResult{
    //    description: string;
    //}

    export interface AddressEntity_Base extends more.EntityAPIResultExtended {
        ID: string;
        Classname: string;
        gDisp_1?: string;
        gDisp_Firstname_Name: string;
        name: string;
        street: string;
        ref_postal_code: PostalCode;
        ref_country: Country;
        note: string;
        is_active: boolean;
        is_perfomer: boolean;
        pseudonym: string;
        tax_no: string;
        VAT_no: string;
        EL_root_ht_files: HtFile[];
        EL_performers_address: any[];
        EL_banking_accounts_address: any[];
        EL_further_addresses_base_address: any[];
        EL_ht_address_adresscategory_address: HtAddressCategoryEntity[];
        EL_vt_telecommunications_adress: TelecommunicationEntity[];

    }

    export interface OrganisationEntity extends AddressEntity_Base {
        name_2: string;
        name_3: string;

    }


    export interface ContactPersonEntity extends AddressEntity_Base {
        gDisp_1: string;
        gDisp_Name_Firstname?: string;
        ref_job_title: JobTitle;
        c_job_title: string;
        ref_person: PersonEntity;
        ref_organisation: OrganisationEntity;
        EL_ht_address_adresscategory_address: HtAddressCategoryEntity[];
        EL_vt_telecommunications_adress: TelecommunicationEntity[];
        ref_address_types: any;
        ref_division?: any;
    }

    export interface AssociateEntity extends ContactPersonEntity {
        EL_vt_internal_contract_md_associate: any[];
    }


    interface Profession extends more.EntityAPIResult{
        description: string;
    }

    export interface AddressSyncType extends more.EntityAPIResult {
        description: string,
        code?: string
    }
    export interface SyncAddress extends more.EntityAPIResult {
        gDisp_1: string,
        name: string
    }
    export interface SuperiorDivision extends more.EntityAPIResult {
        name: string
    }
    //export interface ContactPerson extends more.EntityAPIResult {
    //    gDisp_1: string,
    //    ref_person: {
    //        ID: string,
    //        gDisp_1: string
    //    }
    //}
    export interface Division extends more.EntityAPIResult {
        name: string,
        ref_address_sync_type: AddressSyncType,
        street: string,
        c_postal_code: string,
        c_city: string,
        ref_postal_code: PostalCode,
        ref_country: Country,
        ref_sync_address: SyncAddress,
        ref_superior_division: SuperiorDivision,
        EL_vt_contact_persons_division: Array<ContactPersonEntity>,
        ref_vw_telecom_addresses: {
            phonenumber: string,
            mobilenumber: string,
            emailaddress: string
        }
    }
    export interface AddressDocumentsTableEntry {
        ID: string,
        Classname: string,
        ClassPrintname: string,
        personal_doc_number: string,
        date_valid_from: string,
        date_valid_until: string,
        toDelete?: boolean,
        isNew?: boolean //(Math.random() * 100000).toString()
    }
    export interface AddressDocumentChangeData {
        entryId?: string,
        data: AddressDocumentSaveData
    }
    export interface AddressDocumentSaveData {
        ID: string,
        className: string,
        addressId: string,
        changedData: Object
    }

    export interface FurtherAddressesEntry {
        ID: string,
        description: string,
        street: string,
        c_postal_code: string,
        c_city: string,
        ref_postal_code: PostalCode,
        ref_country: Country,
        toDelete?: boolean,
        isNew?: boolean
    }
    export interface VCardAddressData_Base extends more.EntityAPIResultExtendedGDisp1 {
        building: string;
        street: string;
        c_postal_code: string;
        c_city: string;
        ref_country: Country;
        EL_vt_telecommunications_adress: TelecommunicationEntity[];
    }
    export interface VCardAddressData extends VCardAddressData_Base {
        gDisp_person?: string;
        name?: string;
        name_first?: string;
        name_second?: string;
        name_suffix?: string;
        salutation_short?: string;
        professional_title_short?: string;
        academic_title_short?: string;
        academic_title_suffix_short?: string;
        
        ref_person?: more.EntityAPIResultExtendedGDisp1;
        ref_organisation?: more.EntityAPIResultExtendedGDisp1;
        ref_division?: {
            name: string;
        }
        c_job_title?: string;

        EL_vt_contact_persons_person: VCardAddressData_Base;
    }

    export interface VCardAddressSelectListEntry {
        ID: string;
        label: string;
        organizationName?: string;
    }

    export interface GDPRGetDataResponse {
        entityView?: any;
        tableList?: Array<GDPRAssignment>;
        templates: Array<GDPRTemplate>;
        tableLayout: any;
        isReadonly: boolean;
    }
    export interface GDPRTemplate {
        ID: string;
        code: string;
        description: string;
        gDisp_1: string;
        is_no_expiration: boolean;
    }
    export interface GDPRAssignment {
        ID: string;
        ref_GDPR_template: GDPRTemplate;
        date_GDPR_planned_expiration: Date;
        date_GDPR_last_event: Date;
        note_GDPR: string;
        isNew?: boolean;
        toDelete?: boolean;
    }
}